export enum DocumentType {
  PDF = 'PDF',
  TEXT = 'TEXT',
  JPEG = 'JPEG',
  RAR = 'RAR',
  ZIP = 'ZIP',
  DOCX = 'DOCX',
  XLSX = 'XLSX'
}
